// extracted by mini-css-extract-plugin
export var container = "_dq-0";
export var containerTopRight = "_dq-1";